import { useMemo } from "react";
import { Link } from "react-router-dom";
import { Flex, Icon, Box } from "@chakra-ui/react";

const NavItem = ({ icon, href, children, pathname, ...rest }) => {
  const active = useMemo(() => {
    if (pathname === href) {
      return true;
    }

    return false;
  }, [pathname, href]);
  return (
    <Box style={{ textDecoration: "none" }} _focus={{ boxShadow: "none" }}>
      <Link to={href || "#"}>
        <Flex
          align="center"
          p="4"
          mx="4"
          borderRadius="lg"
          role="group"
          cursor="pointer"
          fontSize="large"
          color={active ? "white" : "whiteAlpha.500"}
          _hover={{
            color: "white",
          }}
          {...rest}
        >
          {icon && (
            <Icon
              mr="4"
              fontSize="20"
              color={active ? "kasbon.500" : "whiteAlpha.500"}
              _groupHover={{
                color: "kasbon.500",
              }}
              as={icon}
            />
          )}
          {children}
        </Flex>
      </Link>
    </Box>
  );
};

export default NavItem;
